import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// MATERILA
import Typography from '@mui/material/Typography';
// CONFIG
import { moduleConfig } from '../../../lib/config/appConstants';

const styles = (theme) => ({
  title: {
    flexGrow: 1,
    paddingLeft: theme.spacing(1),
    textTransform: 'none',
    color: 'white',
  },
});
export class AppNavigation extends React.Component {
  render() {
    if (!this.props || !this.props.module) {
      return <div></div>;
    }

    const { module } = this.props;

    const moduleName =
      module === moduleConfig.PC.shortName ? moduleConfig.PC.fullName : moduleConfig.EB.fullName;

    const moduleIcon =
      module === 'PC' ? (
        <img alt="" src={process.env.PUBLIC_URL + '/img/Factory.svg'} width="24px" height="24px" />
      ) : (
        <img alt="" src={process.env.PUBLIC_URL + '/img/Heart.svg'} width="24px" height="24px" />
      );

    return (
      <Fragment>
        {moduleIcon}
        <Typography variant="h1" sx={(theme) => styles(theme).title} noWrap>
          {moduleName}
        </Typography>
      </Fragment>
    );
  }

  handleAppRedirectWelfare = (evt) => {
    window.open('/app/welfare', '_blank');
  };

  handleAppRedirectRetirement = (evt) => {
    window.open('/app/retirement', '_blank');
  };

  handleAppRedirectAnalytics = (evt) => {
    window.open('/app/analytic', '_blank');
  };

  handleRequestEB = () => {
    this.setState({ open: false });
    this.props.onRequestEB();
  };

  handleRequestPC = () => {
    this.setState({ open: false });
    this.props.onRequestPC();
  };
}

AppNavigation.propTypes = {
  module: PropTypes.oneOf([moduleConfig.PC.shortName, moduleConfig.EB.shortName]).isRequired,
};

export default AppNavigation;
